//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/smsSystems/views/main/lan/en';
import createEditSmsSystem from 'Modules/smsSystems/views/.components/createEditSmsSystem/lan/en';
import deleteSmsSystem from 'Modules/smsSystems/views/.components/deleteSmsSystem/lan/en';

locales = { ...locales, ...main, ...createEditSmsSystem, ...deleteSmsSystem };

export default locales;